function showInstructions() {
    if(trial!=0){hideAll();}//must be smth more elegant than this...
    var head = replaceVariables(columnForTrial('head', trialRow), undefined, undefined, undefined, 1);
    var body = replaceVariables(columnForTrial('body', trialRow), undefined, undefined, undefined, 1);

    displayText("title",replaceVariables(listArrays[allColumns.indexOf('title')][trialRow], undefined, undefined, undefined, 1));//nothing displayed if na
    displayText("content",replaceVariables(listArrays[allColumns.indexOf('content')][trialRow], undefined, undefined, undefined, 1));//nothing displayed if na
    displayText("title", head);
    displayText("content", body);
    showTimer();

    if (typeof stimOrderCounterPart[trial] !== 'undefined' && columnForTrial('type',trialRow)=="instructions")
    {
        displayText("trialInfo",stimOrderCounterPart[trial]);//display "block i of n"
    }

    var tempText

    if (columnForTrial('button1',trialRow)!="na")
    {
        tempText = columnForTrial('button1',trialRow);
    }

    var presTime = Number(columnForTrial('presTime', trialRow)) || 0;
    if (presTime > 0)
    { 
        var itiTime = Number(columnForTrial('ITI', trialRow)) || 0;
        var postponeTime = presTime + itiTime;
        eventTimeOutLearn = postpone(autoAdvance, postponeTime, window.lastTs);
    }

    else if(columnForTrial('responseWindow', trialRow)!="na")
    {
        postpone(autoAdvance, window.listTrialResponseWindow[trialRow].timeout, window.lastTs);
    }

    //if button1 is defined or keyboard and presTime are not defined show the NEXT button with the default text or if present the one in button1
    if (tempText !== undefined || (presTime === 0 && columnForTrial('keyboard',trialRow)=="na"))
    {
        tempText = tempText === undefined ? window.defaultButtonText : tempText;
        showOneButtonStandard(tempText);
    }
    if (columnForTrial('keyboard',trialRow)!="na")
    {
        recordKeys=1;
    }

    alignInstructionsButton();
}